// extracted by mini-css-extract-plugin
module.exports = {"text":"TagsSelect_text__TA_9D","plus":"TagsSelect_plus__NG5VB"};